import React from 'react';
import { Button, Flex, Typography } from 'antd';
import { useWeb3Modal, useDisconnect, useWeb3ModalAccount } from '@web3modal/ethers/react'
import { DisconnectOutlined, ApiOutlined } from '@ant-design/icons';
import { useToast } from './Toaster';
const { Text } = Typography;


export const ConnectButton = () => {
	const { open } = useWeb3Modal();
	const { disconnect } = useDisconnect();
	const { isConnected } = useWeb3ModalAccount()

	return (
		isConnected ? <Button style={{ width: '100px', border: 'solid 2px #000', color: '#000' }} onClick={() => disconnect()}>Disconnect</Button> : <Button style={{ width: '100px', border: 'solid 2px #000', color: '#000' }} onClick={() => open()}>Connect</Button>
	);
}

export const ConnectMenuButton = () => {
	const { open } = useWeb3Modal();
	const { disconnect } = useDisconnect();
	const { isConnected, address } = useWeb3ModalAccount()
	const { pushToast } = useToast();
	const prevConnected = React.useRef(false);

	const connected = isConnected && address;

	React.useEffect(() => {
		if (connected && !prevConnected.current) {
			pushToast('Wallet connected ✓');
		}
		prevConnected.current = connected;
	}, [connected]);
	const walletForeground = connected ? 'var(--accent)' : '#f4f1e8';
	const displayAddress = connected ? `${address.slice(0, 6)}...${address.slice(-4)}` : null;

	return (
		<button
			onClick={() => {
				if (connected) {
					disconnect();
					pushToast('Wallet disconnected');
				} else {
					open();
				}
			}}
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '10px',
				width: '100%',
				borderRadius: '11px 8px 12px 9px',
				border: `2.5px solid ${connected ? 'var(--accent)' : 'rgba(244,241,232,.35)'}`,
				background: connected ? 'var(--accent-wash)' : 'transparent',
				color: walletForeground,
				padding: '13px 10px',
				fontFamily: 'var(--font-display)',
				fontSize: '21px',
				fontWeight: 800,
				cursor: 'pointer',
				transition: 'transform 120ms, background 120ms',
				lineHeight: 1.1
			}}
			onMouseEnter={(e) => { e.currentTarget.style.transform = 'rotate(-0.8deg)'; e.currentTarget.style.background = connected ? 'var(--accent-wash)' : 'rgba(244,241,232,.1)'; }}
			onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.background = connected ? 'var(--accent-wash)' : 'transparent'; }}
		>
			<svg width={22} height={18} viewBox="0 0 22 18" fill="none" style={{ color: walletForeground, flexShrink: 0 }}>
				<rect x="1" y="1" width="20" height="16" rx="3" stroke="currentColor" strokeWidth="2" fill="none" />
				<rect x="14" y="7" width="4" height="4" rx="1" fill="currentColor" />
			</svg>
			{connected ? displayAddress : 'CONNECT WALLET'}
		</button>
	);
}